import React, { PureComponent } from 'react'
import { unreadIndicator } from '../../EmailUtils'
import UTM from '../../../../utils/UTM'
import Wrapper from './StyledWrapper'
import { LogoutLink, InboxLink, MessageLink } from './StyledLink'
import { Header, MailHeading, MailIcon, MailText, DivThemeColor, AddressContainer, InboxLinksContainer } from './StyledHeader'

export default class EmailFullVolny extends PureComponent {
  unreadMessagesPlural (count = 0) {
    let message = 'nepřečtené zprávy'

    if (count === 1) {
      message = 'nepřečtenou zprávu'
    } else if (count >= 5 || count === 0) {
      message = 'nepřečtených zpráv'
    }

    return message
  }

  render () {
    const {
      inbox: {
        summary: {
          unread = 0
        } = {},
        sender: {
          address
        } = {}
      } = {},
      widget: {
        meta: {
          logout,
          inbox
        },
        utmMedium,
        utmSource
      }
    } = this.props
    const inboxLink = new UTM(inbox.location).getUTMLink({utmMedium, utmSource})
    const messageLink = new UTM(`${inbox.location}?pg=newmsg`).getUTMLink({utmMedium, utmSource})

    return (
      <Wrapper>
        <Header>
          <MailHeading>
            <MailIcon src={`${STATICS_PATH}images/email/mail-icon-volny.png`} alt='Volný.cz Mail'/>
            Volný.cz Mail
          </MailHeading>
          <MailText>
            Dobrý den,<br/>
            máte <DivThemeColor>{ unreadIndicator(unread) }</DivThemeColor> { this.unreadMessagesPlural(unread) }.
          </MailText>
          <LogoutLink href={logout.location}>
            { logout.text }
          </LogoutLink>
          <AddressContainer>
            { address }
          </AddressContainer>
          <InboxLinksContainer>
            <InboxLink href={inboxLink}>Přejít do emailu</InboxLink>
            <MessageLink href={messageLink}>Nová zpráva</MessageLink>
          </InboxLinksContainer>
        </Header>
      </Wrapper>
    )
  }
}
